import { motion } from "framer-motion";
import { Ship, FileCheck, Car, Calculator, Shield, Headphones } from "lucide-react";

const services = [
  {
    icon: Car,
    title: "Подбор автомобиля",
    description: "Поиск и проверка авто по вашим критериям на аукционах и у дилеров",
    highlight: true,
  },
  {
    icon: Calculator,
    title: "Расчёт стоимости",
    description: "Точный расчёт всех платежей: таможня, доставка, сертификация",
  },
  {
    icon: Ship,
    title: "Доставка",
    description: "Логистика из Китая, Кореи и США морем и автотранспортом",
  },
  {
    icon: FileCheck,
    title: "Растаможка",
    description: "Полное таможенное оформление и уплата всех пошлин",
  },
  {
    icon: Shield,
    title: "Сертификация",
    description: "Получение СБКТС для регистрации в ГАИ",
  },
  {
    icon: Headphones,
    title: "Поддержка",
    description: "Консультации и сопровождение на всех этапах",
  },
];

export default function ServicesSection() {
  return (
    <section 
      id="services" 
      className="py-24 bg-[#050505]"
      data-testid="services-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <p className="text-white/40 text-xs uppercase tracking-[0.3em] mb-4">
            Что мы предлагаем
          </p>
          <h2 className="text-4xl md:text-6xl text-white font-normal">
            Услуги
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className={`group bg-[#050505] p-10 hover:bg-[#0A0A0A] transition-colors duration-500 ${
                service.highlight ? "lg:col-span-1 lg:row-span-1" : ""
              }`}
              data-testid={`service-${index}`}
            >
              <service.icon 
                className="w-8 h-8 text-white/40 group-hover:text-white transition-colors duration-500 mb-8" 
                strokeWidth={1} 
              />
              <h3 className="text-white text-xl font-normal mb-4 font-sans">
                {service.title}
              </h3>
              <p className="text-white/50 text-sm leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
